import { motion } from "framer-motion";
import { Clock, ArrowRight } from "lucide-react";
import { PLANS, PRICE_NOTE, planLabel } from "../../content/site";
import { Reveal, EASE } from "./motion";
import { scrollToId } from "./useLenis";
import { Calculator } from "./Calculator";

const pick = (p) => {
  window.dispatchEvent(new CustomEvent("gw:service", { detail: planLabel(p) }));
  scrollToId("kontakt");
};

const PlanCard = ({ p, i }) => {
  const dark = i === 1;
  return (
    <motion.div
      data-testid={`plan-card-${p.key}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay: i * 0.12 }}
      whileHover={{ y: -6 }}
      className={`flex flex-col rounded-[28px] p-7 md:p-9 ${dark ? "bg-[#1E5631] text-[#FBF9F4]" : "border border-[#E2DDD0] bg-white text-[#1B281E]"}`}
    >
      <span className={`inline-flex w-fit items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ${dark ? "bg-[#DCEFBE] text-[#1E5631]" : "bg-[#F3EFE6] text-[#1E5631]"}`}>
        <Clock className="h-3.5 w-3.5" /> {p.hours} Stunden im Monat
      </span>
      <p className="mt-8 flex items-baseline gap-2">
        <span data-testid={`plan-price-${p.key}`} className="font-display text-6xl font-medium tracking-tight">{p.price} €</span>
        <span className={dark ? "text-[#FBF9F4]/85" : "text-[#4B5B4E]"}>monatlich</span>
      </p>
      <p data-testid={`plan-hourly-${p.key}`} className={`mt-1 text-sm ${dark ? "text-[#DCEFBE]" : "text-[#8C6D53]"}`}>
        entspricht {(p.price / p.hours).toLocaleString("de-DE", { style: "currency", currency: "EUR" })} pro Stunde
      </p>
      <p className={`mt-4 leading-relaxed ${dark ? "text-[#FBF9F4]/90" : "text-[#4B5B4E]"}`}>
        {p.hours} Stunden Gartenpflege pro Monat – für die Arbeiten, die in Ihrem Garten gerade anstehen.
      </p>
      <button
        data-testid={`plan-cta-${p.key}`}
        onClick={() => pick(p)}
        className={`group mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 font-semibold transition-[background-color,transform] duration-300 hover:-translate-y-0.5 ${
          dark ? "bg-[#FBF9F4] text-[#1B281E] hover:bg-white" : "bg-[#1E5631] text-[#FBF9F4] hover:bg-[#164223]"
        }`}
      >
        Abo anfragen <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </motion.div>
  );
};

export const Plans = () => (
  <div id="abo" data-testid="plans-section" className="mt-24 md:mt-32">
    <Reveal>
      <p className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
        <span className="h-px w-8 bg-[#C86D51]" /> Gartenpflege im Abo
      </p>
      <h3 className="font-display text-3xl font-medium tracking-[-0.02em] text-[#1B281E] sm:text-4xl lg:text-5xl">Regelmäßig gepflegt – zum festen Monatspreis.</h3>
    </Reveal>
    <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
      {PLANS.map((p, i) => <PlanCard key={p.key} p={p} i={i} />)}
    </div>
    <p data-testid="plans-price-note" className="mt-6 text-sm text-[#4B5B4E]">{PRICE_NOTE}</p>
    <Calculator />
  </div>
);
